export const BackOfficeLoader = {
  bo_list_board: 'bo_list_board',
  bo_list_process: 'bo_list_process',
  bo_list_structure: 'bo_list_structure',
  bo_detail_structure: 'bo_detail_structure',
  bo_job_level: 'bo_job_level',
  bo_report_to: 'bo_report_to',
  bo_list_employee: 'bo_list_employee',
  bo_category_group: 'bo_category_group',
  bo_classification: 'bo_classification',
  bo_activityType: 'bo_activityType',
  bo_compLibrary: 'bo_compLibrary',
  bo_orgParameter: 'bo_orgParameter',
  bo_directorate: 'bo_directorate',
  bo_fte: 'bo_fte',
  bo_levelDesc: 'bo_levelDesc',
  bo_member: 'bo_member',
  bo_region: 'bo_region',
  bo_skillGroup: 'bo_skillGroup',
  bo_sub_skill_group: 'bo_sub_skill_group',
  bo_competency_detail: 'bo_competency_detail',
  bo_workerType: 'bo_workerType',
};

export const InitialStateBackOffice = {
  bo_list_board: true,
  bo_list_process: true,
  bo_list_structure: true,
  bo_detail_structure: false,
  bo_job_level: true,
  bo_report_to: true,
  bo_list_employee: true,
  bo_category_group: true,
  bo_classification: true,
  bo_activityType: true,
  bo_compLibrary: true,
  bo_orgParameter: true,
  bo_directorate: true,
  bo_fte: true,
  bo_levelDesc: true,
  bo_member: true,
  bo_region: true,
  bo_skillGroup: true,
  bo_workerType: true,
  bo_sub_skill_group: true,
  bo_competency_detail: true,
};
